<template>
  <div style="width: 100%; height: 100%">
    <NuxtPage />
  </div>
</template>

<script setup lang="ts"></script>
